import { ICampaignSoftOffer, ISoftOfferPackage } from "../types";
import SoftOfferPackageFactory from "../../../factories/campaigns/SoftOfferPackageFactory";

export default class SoftOffer implements ICampaignSoftOffer {

  id: number;
  offerId: number;
  optionName: string;
  saveDesk: boolean;
  p2p: number;
  upsell: number;
  featuredPackages: ISoftOfferPackage[];
  unFeaturedPackages: ISoftOfferPackage[];
  p2pDj: number;
  desc: string;
  generalInfo: string;
  typeSuffix?: string;
  constructor(
    id: number,
    offerId: number,
    optionName: string,
    saveDesk: string,
    p2p: number,
    upsell: number,
    featuredPackages: ISoftOfferPackage[],
    unFeaturedPackages: ISoftOfferPackage[],
    p2pDj: number,
    desc: string,
    generalInfo: string,
    typeSuffix: string | undefined
  ) {
    this.id = id;
    this.offerId = offerId;
    this.optionName = optionName;
    this.saveDesk = !!saveDesk;
    this.p2p = p2p;
    this.upsell = upsell;
    this.featuredPackages = [];
    this.unFeaturedPackages = [];
    this.p2pDj = p2pDj;
    this.desc = desc;
    this.generalInfo = generalInfo;
    if (featuredPackages) {
      featuredPackages.forEach((softOfferPackage: ISoftOfferPackage) => {
        this.featuredPackages.push(SoftOfferPackageFactory.create(softOfferPackage));
      });
    }
    if (unFeaturedPackages) {
      unFeaturedPackages.forEach((softOfferPackage: ISoftOfferPackage) => {
        this.unFeaturedPackages.push(SoftOfferPackageFactory.create(softOfferPackage));
      });
    }
    this.typeSuffix = typeSuffix;
  }

}
